<template>
  <div
    class="notifications bg-secondary text-white"
    :class="{ 'pt-2 pb-2': notifications.length, 'border-bottom': !notifications.length }"
  >
    <div class="row">
      <div v-for="(notification, i) in notifications" :key="i" class="col">
        <RentalObjectNotification :notification="notification" variation="solid" :showTooltip="false" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notifications {
  padding-left: 70px;
  padding-right: 45px;
}
</style>

<script>
import { mapGetters } from 'vuex';
import RentalObjectNotification from '@/components/single-object/RentalObjectNotification.vue';

export default {
  props: {
    rentalObjectId: Number,
  },

  computed: {
    ...mapGetters(['getRentalObjectNotifications']),

    notifications() {
      return this.getRentalObjectNotifications(this.rentalObjectId);
    },
  },

  components: {
    RentalObjectNotification,
  },
};
</script>
